module.exports = __webpack_public_path__ + "img/desc_top_001.7f81530c.png";